/**
 * Read-only / editable text field used inside the case-defaults section.
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'

interface DefaultsFieldProps {
  label: string
  value: string | null | undefined
  editValue: string
  editMode: boolean
  onChange: (value: string) => void
  placeholder?: string
}

export function DefaultsField({
  label,
  value,
  editValue,
  editMode,
  onChange,
  placeholder,
}: DefaultsFieldProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div>
      <label className="mb-1 block text-xs font-medium text-stone-600 dark:text-stone-400">
        {label}
      </label>
      {editMode ? (
        <input
          type="text"
          value={editValue}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-sm text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
          placeholder={placeholder}
        />
      ) : (
        <p className="text-sm text-stone-900 dark:text-stone-100">
          {value ?? t('adminSettings.notSet')}
        </p>
      )}
    </div>
  )
}
